// app/src/lib/toast.jsx — the transient bottom-centre confirmation pill (handoff §interactions:
// toasts for Remix/Share/Download/Apply/Save, ~2s). One provider; useToast() → show(msg).

import React, { createContext, useContext, useState, useRef, useCallback } from 'react';

const ToastCtx = createContext(() => {});

export function ToastProvider({ children }) {
  const [msg, setMsg] = useState(null);
  const timer = useRef(null);
  const show = useCallback((m) => {
    setMsg(m);
    if (timer.current) clearTimeout(timer.current);
    timer.current = setTimeout(() => setMsg(null), 2100);
  }, []);
  return (
    <ToastCtx.Provider value={show}>
      {children}
      {msg && <div className="toast" role="status">{msg}</div>}
    </ToastCtx.Provider>
  );
}

export function useToast() {
  return useContext(ToastCtx);
}
